import { FunctionComponent, KeyboardEvent } from 'react'
import classnames from 'classnames'
import { Banner as BannerProps, BannerVariant } from './Banner.types'
import { Image } from 'src/componentsV2/CoreUX/primitives/Image/Image'
import { Button } from 'src/componentsV2/CoreUX/primitives/Button/Button'
import { Text } from 'src/componentsV2/CoreUX/primitives/Text/Text'
import { useActions } from 'src/hooks/useActions'
import './Banner.scss'

export const Banner: FunctionComponent<BannerProps> = ({
  attributes: { variant, title, subtitle, image, button },
  actions
}) => {
  const { onClick } = useActions(actions)

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick?.()
    }
  }

  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      className={classnames('core-ux-banner', {
        'core-ux-banner-card': variant === BannerVariant.CARD,
        'core-ux-banner-hero': variant === BannerVariant.HERO
      })}
      data-testid="banner">
      <Image {...image} />
      <div className="core-ux-banner__content">
        <div className="core-ux-banner__text-container">
          <Text {...title} className="core-ux-banner__text-truncated" />
          <Text
            {...subtitle}
            className="core-ux-banner__subtitle core-ux-banner__text-truncated"
          />
        </div>
        {button && <Button {...button} className="core-ux-banner__button" />}
      </div>
    </div>
  )
}
